import React from 'react';
import styles from "../styles.module.scss";

const Index = ({t}) => {

  return (
    <div className={styles["support"]}>
      <h3 className={styles["block-header"]}>{t("support.header")}</h3>
      <p>{t("support.text")}</p>
    </div>
  );
};

export default Index;